import { WebPageDetails } from "@/services/analytics/platforms/adobe-analytics/models";
import { AdobePageLoadEvent } from "./adobe-page-load";
import { Store } from "vuex";
import { AppState } from "@/store";
import { ServicesContainer } from "@/services";
import router from "@/router";


export class AdobePceLandingPageLoadEvent extends AdobePageLoadEvent {
  eventType? : string;
  constructor(store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    const groupName = router.currentRoute.params.groupName;
    
    this.eventType = 'web.webpagedetails.pageViews';

    if (!services.order.getCurrentOrder()) {
      this.commerce.startOrder = { value: 1 };
    }

    Object.assign(this.web.webPageDetails, this.createMealBuilderDetails(groupName));
  }
  
  createMealBuilderDetails(groupName: string) : WebPageDetails{
    const siteSection = 'order';
    const subSection1 = 'landing-page';
    const subSection2 = '';
    const pageType = `landing-page`
    const pageViews = {
      value: 1,
    }

    let details = {
      pageType,
      siteSection,
      subSection1,
      subSection2,
      pageViews,
      name: `${siteSection}:${subSection1}:pce-${this.getPcePageName(groupName)}`
    } as WebPageDetails

    return details;
  }

  getPcePageName(groupName: string): string {
    switch(groupName) {
      case 'build-your-own':
        return 'byoc';
      case 'high-protein-menu':
        return 'high-protein-meals';
      default: 
        return groupName;
    }
  }
}